import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill", "fill-opacity"]

import { PropType } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PinIcon18',
  props: {
    fill: {
      type: String,
      default: 'black',
    },
    fillOpacity: {
      type: String as PropType<'1' | '0.54'>,
      default: '0.54',
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M8.99988 0C5.40532 0 2.48096 2.92437 2.48096 6.51888C2.48096 10.9798 8.31475 17.5287 8.56313 17.8053C8.79643 18.0651 9.20375 18.0647 9.43662 17.8053C9.685 17.5287 15.5188 10.9798 15.5188 6.51888C15.5187 2.92437 12.5944 0 8.99988 0ZM8.99988 9.79871C7.19137 9.79871 5.72008 8.32739 5.72008 6.51888C5.72008 4.71037 7.1914 3.23909 8.99988 3.23909C10.8083 3.23909 12.2796 4.71041 12.2796 6.51892C12.2796 8.32743 10.8083 9.79871 8.99988 9.79871Z",
      fill: __props.fill,
      "fill-opacity": __props.fillOpacity
    }, null, 8, _hoisted_2)
  ]))
}
}

})